<template>
  <div style="display: contents">
    <input type="text" name="customer" :placeholder="usageArea === 'bets' ? t.bet_ticket_query : t.search"
           autocomplete="off"
           class="form-control musteri-search"
           :class="$route.name !== 'Home' ? 'p-1' : ''"
           @keyup="fetchUsers"
           v-model="search" @focusin="show = true">
    <div class="easy-autocomplete-container" v-show="show">
      <ul>
        <li v-for="(user, idx) in users"
            :key="idx" @click="handleUser(user)">
          <div class="eac-item">
            <b>{{ user.first_name }}</b> ({{ user.id }})
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerSearch",
  data() {
    return {
      t: this.$root.t,
      api: window.api,
      search: '',
      show: false,
      users: null,
      uid: '',
      selected: false
    }
  },
  props: ['usageArea', 'list'],
  watch: {
    'search' () {
      //this.fetchUsers();
    }
  },
  methods: {
    fetchUsers() {
      if(this.search.length >= 3) {
        this.$http.get(api + 'api/v1/ba/search/'+this.search.toLowerCase(), {params: {q: this.search}}).then(response => {
          this.users = [];

          response.body.result.forEach((v) => {
            if(this.usageArea == 'reseller'){
              if(!v.roles.includes('ROLE_CREATE_SUB_RESELLER') && v.roles.includes('ROLE_RESELLER')){
                this.users.push(v);
              }
            }

            if(this.usageArea == 'admin'){
              if(v.roles.includes('ROLE_SELLER')){
                this.users.push(v);
              }
            }

            if(this.usageArea == 'customer' || this.usageArea == 'client'){
              if(v.roles.includes('ROLE_CLIENT')){
                this.users.push(v);
              }
            }
          })
        }, response => {
        })
      }

    },

    handleUser(user) {

      this.$emit('result', user);

      if (this.usageArea === 'customer') {
        if(!this.list)
          this.$router.push({name: 'CustomerDetail', params: {id: user.id}})

        if(this.list)
          this.goArea(user)

      }if (this.usageArea === 'reseller') {
        if(!this.list)
          this.$router.push({name: 'ResellerInfo', params: {id: user.id}, query: {referrer: user.reference}})

        if(this.list)
          this.goArea(user)
      }if (this.usageArea === 'admin') {
        if(!this.list)
          this.$router.push({name: 'AdminInfo', params: {id: user.id}, query: {referrer: user.reference}})

        if(this.list)
          this.goArea(user)
      }if (this.usageArea === 'client') {
        if(!this.list)
          this.$router.push({name: 'AdminInfo', params: {id: user.id}, query: {referrer: user.reference}})

        if(this.list)
          this.goArea(user)
      } else {

      }
    },
    goArea(user){
      this.$parent.uid = user.id;
      this.search = user.username;
      this.show = false;
      this.$router.push({query: {uid: user.id, page: 1}});
    }
  }
}
</script>

<style scoped>
.hide {
  display: none;
}

.show {
  display: block;
}

.easy-autocomplete-container li:hover {
  cursor: pointer;
  background: #f1f2f2;
}

</style>



// WEBPACK FOOTER //
// src/components/CustomerSearch.vue